/**
 * ProtectedRoute
 * ==============
 *
 * Wraps app routes that require an authenticated user. If there's no
 * session yet:
 *   - While Supabase is still figuring out the cached session
 *     (``loading=true``), show a spinner so we don't bounce to /login
 *     on every cold load (especially annoying on refresh).
 *   - Once ``loading=false`` and ``session=null``, redirect to /login
 *     with ``state.from = current path`` so LoginPage can return the
 *     user to where they started after sign-in.
 */
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export default function ProtectedRoute() {
  const { session, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div className="h-full flex items-center justify-center text-sm text-slate-500">
        Loading…
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: loc.pathname + loc.search }} />;
  }

  return <Outlet />;
}
